import React, { memo, Suspense } from 'react';
import { getYStepSize } from '@components/destinations/destination-view/events/utils';
import { Skeleton } from 'antd';

const Chart = React.lazy(() => import('@components/common/chart'));

interface Props {
  chartData?: {
    bucket: number;
    sentCount: number | null;
  }[];
  labelFormat: string;
}

export default memo(({ chartData, labelFormat }: Props) => {
  if (!chartData) {
    return null;
  }
  const delivered = chartData.map((x) => x.sentCount);
  const stepSize = getYStepSize(delivered, []);

  const data = chartData.map((elem) => ({
    bucket: elem.bucket,
    chart1: elem.sentCount,
  }));

  return (
    <Suspense fallback={<Skeleton active />}>
      <Chart chartData={data} stepSize={stepSize} labelFormat={labelFormat} labels={['Ingested']} />
    </Suspense>
  );
});
